<template>
  <b-container>
    <b-form @submit.prevent="requestTemporaryPassword">
      <b-form-group
        class="pt-4"
        id="input-group-username"
        label="Username"
        label-for="input-username">
        <b-form-input
          id="input-username"
          required
          v-model="username"
          type="text"
          placeholder="enter username">
        </b-form-input>
      </b-form-group>
      <b-button
        block
        type="submit"
        :disabled="waiting"
        variant="outline-primary" 
        size="lg">
        Request recovery password <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
      </b-button>
    </b-form>
  </b-container>
</template>

<script>
import { authService } from '../_services';
export default {
  data() {
    return {
      waiting: false,
      username: '',
    }
  },
  methods: {
    requestTemporaryPassword() {
      this.waiting = true
      let vm = this
      authService.forgotPassword(this.username)
      .then((resp) => {
        this.$bvModal.msgBoxOk(`a recovery password will be sent to the 
        cellphone number linked to that username, if the user exists.`)
        vm.waiting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/PasswordRecoveryPage.vue